export default __webpack_public_path__ + "static/media/expand.bd2aebe1.svg";